import * as types from '../constants/ActionTypes'
const objectAssign = require('object-assign');

const initialState = {
	  data:{},
    customerParams:{
    	search: '',
    	current: 1,
    	pageSize: 20,
    	access_token: ''
    },
    orderFields: {},
    customerList: [],
    customerCount: 0,
    licenses:""
};

export default function app(state = initialState, action) {
  switch (action.type) {
  	case types.CHOOSE_CUSTOMER:
  		return objectAssign({}, state, {orderFields :objectAssign({}, state.orderFields, {c_id:{value:action.data.id},c_name:{value:action.data.name}})});
  	case types.GET_LICENSE:
  		return objectAssign({}, state, {
  			orderFields: objectAssign(
  				{}, state.orderFields,{
  					license:{name:'license',value:action.data}
  				})
  			});
  	case types.RESET_CUSTOMER_PARAMS:
  		return objectAssign({}, state, {customerParams: objectAssign({}, initialState.customerParams,{access_token: !!localStorage.me ? JSON.parse(localStorage.me).token.access_token : ''})});
  	case types.GO_NEXT_PAGE:
	  	return objectAssign({}, state, {customerParams: objectAssign({}, state.customerParams,action.data)});
  	case types.GET_CUSTOMER_LIST:
  		return objectAssign({}, state, 
  			{customerList: state.customerParams.current == 1 ? action.data.list : state.customerList.concat(action.data.list),
  			customerCount: action.data.count
  			});
  	case types.SAVE_ORDER_FIELDS:
  		return objectAssign({}, state, {orderFields:action.data});
    case types.GET_APP:
      return objectAssign({}, state, {data:action.data});
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./project/reducers/app.js